// extracted by mini-css-extract-plugin
export default {"mainCard":"Card_mainCard__2rBtI"};